const isIE = () => {
    if (!!window.ActiveXObject || 'ActiveXObject' in window) {
        return true;
    } 
        return false;
    
};
const isIE11 = () => {
    if (/Trident\/7\./.test(navigator.userAgent)) {
        return true;
    } 
        return false;
    
};

const isFirefox = () => {
    if (/Firefox/.test(navigator.userAgent)) {
        return true;
    } 
        return false;
    
};

const isSafari = () => {
    if (/Safari/.test(navigator.userAgent)) {
        return true;
    } 
        return false;
    
};

export default {
    isIE,
    isIE11,
    isFirefox,
    isSafari,
};



// WEBPACK FOOTER //
// ./src/util/judgeBroswer.js